import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import Ajax from "superagent"
import { set, omit, cloneDeep, isEmpty} from 'lodash'

import { partners } from "../../../../data"

function updateSelections(state = {}, action) {
  if (action.type == "UPDATE_CART") return action.payload
  
  else if (action.type == "UPDATE_USER_DATA") {
    return {...state, userData: action.payload}
  }
  else if (action.type == "UPDATE_PRODUCT_DATA") {
    return {...state, ...action.payload}
  }
  else if (action.type == "DELETE_PRODUCT_DATA") {
    return omit(state, action.payload)
  }
  else return state
}


function transportationReducer(state = {}, action = {}) {
  if (action.type == "TRANSPORTATION_FORM") {
    return {
      ...state, 
      [action.payload.city] : {...state[action.payload.city], ...action.payload.payload}
    }
  }
  else return state
}

function setuserInfo(state = {}, action = {}) {
  if (isEmpty(state)) {
    const subdom = window.location.hostname.split(".").filter(x => x != "www")[0]
    const partner = partners.find(p => p.domain == subdom)

    const browserAgent = navigator.userAgent
    const vendor = browserAgent.search('MicroMessenger') != -1 ? "wechatpay" : "alipay"
    const isWeIos = browserAgent.search('MicroMessenger') != -1 && browserAgent.search('iPhone') != -1
    return {
      ...state, 
      browserAgent, 
      isWeIos,
      vendor,
      partner
    }
  }
  else return state
}

function managePaths(state = [], action = {}) {
  const newArray = state
  if (action.type == "@@router/LOCATION_CHANGE") {
    if (newArray.length != 0) {
      if (action.payload.action == "PUSH" && window.location.pathname != newArray[newArray.length - 1]) {
        newArray.push(window.location.pathname)
      }
      else if (action.payload.action == "POP") {
        // Hacemos estas dos distinciones, porque un adelante en el historial, que nosostros lo interpretariamos como un PUSH, llega como un POP
        if (window.location.pathname == newArray[newArray.length - 2]) {
          newArray.pop()
        }
        else if (window.location.pathname != newArray[newArray.length - 1]) {
          newArray.push(window.location.pathname)
        }
      }
    }
    else newArray.push(window.location.pathname)
  } 

  return state
}

const reducer = combineReducers({
  routing: routerReducer,
  transportation: transportationReducer, 
  selections: updateSelections,
  userInfo: setuserInfo,
  history: managePaths,
})

export default reducer



// WEBPACK FOOTER //
// ./src/app/catalogo/store/reducer.js